import * as React from 'react';
import { getToken } from './auth';
import { Navigate } from 'react-router';

const ProtectedRoute = ({ children }) => {
	let isAuthenticated = getToken();
	if (!isAuthenticated) {
		<Navigate to={`/auth`} replace />;
	}

	return children;
};
export default ProtectedRoute;
